import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
const steps = [{
  num: '1️⃣',
  title: 'COMPRÁS',
  desc: 'Ingresás tu correo y completás el pago.'
}, {
  num: '2️⃣',
  title: 'PAGÁS',
  desc: 'Pagás de forma segura con Mercado Pago, tarjeta o transferencia.'
}, {
  num: '3️⃣',
  title: 'ACCEDÉS',
  desc: 'Recibís el acceso y el material digital para descargar.'
}];
export function HowItWorks() {
  return <section className="py-10 sm:py-20 px-4" data-id="element-143">
      <div className="max-w-4xl mx-auto" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 5
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10px'
      }} transition={{
        duration: 0.2
      }} className="text-center mb-8 sm:mb-12" data-id="element-145">
          <h2 className="text-3xl sm:text-4xl font-black text-white flex items-center justify-center gap-3 drop-shadow-lg uppercase" data-id="element-146">
            🔽 ¿CÓMO RECIBÍS EL MATERIAL?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-8 mb-8 sm:mb-12" data-id="element-147">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-20px'
        }} transition={{
          duration: 0.2,
          delay: index * 0.05
        }} className="text-center flex flex-col items-center bg-green-950/40 p-8 rounded-2xl border border-green-700/20" data-id="element-148">
              <div className="text-5xl mb-4" data-id="element-149">{step.num}</div>
              <h3 className="text-xl font-bold text-white mb-2 uppercase" data-id="element-150">
                {step.title}
              </h3>
              <p className="text-white/80 font-medium" data-id="element-151">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}